import { render, staticRenderFns } from "./blockEditDialog.vue?vue&type=template&id=fa0e8b44&scoped=true&"
import script from "./blockEditDialog.vue?vue&type=script&lang=js&"
export * from "./blockEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./blockEditDialog.vue?vue&type=style&index=0&id=fa0e8b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0e8b44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDialog,VIcon,VSheet})
